import React from 'react'
import styled from 'styled-components'
import theme from '@shared/utils/theme'

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  color: ${ theme.palette.black };
  .page{
    max-width: 1024px;
    width: 100%;
    height: 100%;
  }
`

function Layout({ children }) {
  return (
    <LayoutContainer>
      <div className="page">
        { children }
      </div>
    </LayoutContainer>
  )
}

export default Layout
